export default __webpack_public_path__ + "static/media/ilha_7.5be466ab.jpg";